export type SelectTableRemoteConfig = {
  url: string;
  method: 'get' | 'post';
};

export const varients: Record<string, SelectTableRemoteConfig> = {
  // 工厂下拉
  factory: {
    url: '/components/componentWerks',
    method: 'post',
  },
  // 生产线下拉
  productionLine: {
    url: '/components/componentProductionLine',
    method: 'post',
  },
  // 获取工厂对应的班组信息
  workRoom: {
    url: '/components/componentWorkRoom',
    method: 'post',
  },
  // 物料下拉
  materials: {
    url: '/dailySchedule/getJhMaterial',
    method: 'post',
  },
  // 生产版本下啦
  productionVersion: {
    url: '/dailySchedule/getMatnrVerid',
    method: 'post',
  },
  // 分公司下拉
  getBranch: {
    url: '/orderCoordination/queryCompanyCombobox',
    method: 'post',
  },
  // 小样反馈-项目下拉
  getProject: {
    url: '/sample/queryReport',
    method: 'post',
  },
  //加工物料类
  getMaterialTwo: {
    url: '/sy/getMaterialTwo',
    method: 'post',
  },
};

export type Varient = keyof typeof varients;
